// Module
var code = `<template class="main-customer-lookup">
  <require from="./main-customer-lookup.scss"></require>
  <div mdc-menu-surface-anchor>
    <mdc-text-field ref="input" view-model.ref="inputVm" focus.trigger="handleFocus()">
      <button mdc-icon-button mdc-text-field-icon trailing icon="settings" tabindex="0" click.trigger="gotoSettings() & stopPropagation"></button>
    </mdc-text-field>
    <mdc-lookup options.bind="getOptions" view-model.ref="lookup" display-field="name" debounce="0" value.bind="value" input.bind="input" preload-options natural-width hoist-to-body perfect-scrollbar>
    </mdc-lookup>
  </div>
</template>

`;
// Exports
export default code;